/**
 * Mega Menu component.
 */
const { addFilter } = wp.hooks;

/* global navigator */
class MegaMenu {
	/**
	 * Constructs the MegaMenu object and initialises DOM elements.
	 */
	constructor() {
		this.root = document.documentElement;
		this.header = document.querySelector( '.site-header' );
		this.uspBar = document.querySelector( '.usp-bar' );
		this.infoBar = document.querySelector( '.info-bar' );
		this.burgerMenu = document.querySelector( '.header__burger' );
		this.closeMenu = document.querySelector( '.header__menu-close' );
		this.headerMenu = document.querySelector( '.header__menu' );
		this.subMenuCloses = document.querySelectorAll( '.header__menu-sub-close' );
		this.menuItems = document.querySelectorAll( '.header__menu-item--parent' );
		this.menuSubWrapper = document.querySelector( '.header__menu-sub-wrapper' );
	}

	/**
	 * Initialises the Mega Menu by setting dynamic heights and setting up event listeners.
	 */
	init() {
		if ( ! this.header ) {
			return;
		}

		this.adjustQalaMenu();
		this.setDynamicHeights();
		this.setupMenuInteractions();
		// I dont think this is needed?
		// this.setupScrollBehaviour();
	}

	/**
	 * Stop the main menu from being sticky. This project requires only the secondaryHeader to be sticky.
	 */
	adjustQalaMenu() {
		addFilter( 'qala_theme.filter.pre_disable_sticky_menu', 'polestar', function( isSticky ) {
			if ( ! isSticky ) {
				return true;
			}
		}, 10 );
	}

	/**
	 * Sets dynamic heights based on the elements' actual sizes and updates CSS custom properties.
	 */
	setDynamicHeights() {
		const headerHeight = this.header ? this.header.offsetHeight + 'px' : '0px';
		const uspBarHeight = this.uspBar ? this.uspBar.offsetHeight + 'px' : '0px';
		const infoBarHeight = this.infoBar ? this.infoBar.offsetHeight + 'px' : '0px';

		this.root.style.setProperty( '--header-height', headerHeight );
		this.root.style.setProperty( '--usp-bar-height', uspBarHeight );
		this.root.style.setProperty( '--info-bar-height', infoBarHeight );
	}

	/**
	 * Sets up event listeners for menu interactions such as opening and closing menus.
	 */
	setupMenuInteractions() {
		const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

		this.burgerMenu.addEventListener( 'click', () => {
			this.header.classList.add( 'header--active' );
			this.headerMenu.classList.add( 'header__menu--active' );
		} );

		this.closeMenu.addEventListener( 'click', () => {
			this.header.classList.remove( 'header--active' );
			this.headerMenu.classList.remove( 'header__menu--active' );
			deactivateSubmenu();
		} );

		/**
		 * Activates a submenu based on the data attribute of the clicked item.
		 *
		 * @param {HTMLElement} item - The menu item that triggers submenu activation.
		 */
		const activateSubmenu = item => {
			const submenuData = item.getAttribute( 'data-submenu' );
			if ( submenuData ) {
				// Deactivate all submenus first
				setTimeout( () => {
					const allSubMenus = this.menuSubWrapper.querySelectorAll( '.header__menu-sub--active' );
					allSubMenus.forEach( subMenu => {
						subMenu.classList.remove( 'header__menu-sub--active' );
					} );
				}, 150 );

				// Add active class to new submenu
				if ( this.menuSubWrapper ) {
					this.menuSubWrapper.classList.add( 'header__menu-sub-wrapper--active' );
					const subMenu = this.menuSubWrapper.querySelector( `.header__menu-sub[data-submenu="${ submenuData }"]` );
					if ( subMenu ) {
						setTimeout( () => {
							subMenu.classList.add( 'header__menu-sub--active' );
						}, 150 );
					}
				}
			}
		};

		/**
		 * Deactivates any active submenu.
		 *
		 * @param {HTMLElement} item
		 */
		const deactivateSubmenu = item => {
			if ( ! item ) {
				// If no item is provided, find any active submenu and deactivate it
				const activeSubMenus = this.menuSubWrapper.querySelectorAll( '.header__menu-sub--active' );
				activeSubMenus.forEach( subMenu => {
					subMenu.classList.remove( 'header__menu-sub--active' );
					// Also deactivate the wrapper if needed
					if ( this.menuSubWrapper.classList.contains( 'header__menu-sub-wrapper--active' ) ) {
						this.menuSubWrapper.classList.remove( 'header__menu-sub-wrapper--active' );
					}
				} );
			} else {
				const submenuData = item.getAttribute( 'data-submenu' );
				if ( submenuData ) {
					if ( this.menuSubWrapper ) {
						this.menuSubWrapper.classList.remove( 'header__menu-sub-wrapper--active' );
						const subMenu = this.menuSubWrapper.querySelector( `.header__menu-sub[data-submenu="${ submenuData }"]` );
						if ( subMenu ) {
							subMenu.classList.remove( 'header__menu-sub--active' );
						}
					}
				}
			}
		};

		let submenuTimeout;
		this.menuItems.forEach( item => {
			item.addEventListener( 'mouseover', event => {
				if ( ! isTouchDevice && event.target === item ) {
					clearTimeout( submenuTimeout );
					this.header.classList.add( 'header--active' );
					this.header.style.backgroundColor = 'unset';
					activateSubmenu( item );
				}
			} );

			this.menuSubWrapper.addEventListener( 'mouseleave', e => {
				e.stopPropagation();
				e.stopImmediatePropagation();
				e.preventDefault();
				if ( ! isTouchDevice ) {
					this.header.classList.remove( 'header--active' );
					this.header.style.backgroundColor = 'revert-layer';
					deactivateSubmenu( item );
				}
			} );

			item.addEventListener( 'click', function() {
				activateSubmenu( this );
			} );
		} );

		this.subMenuCloses.forEach( subMenuClose => {
			subMenuClose.addEventListener( 'click', function( event ) {
				event.stopPropagation();
				deactivateSubmenu();
			} );
		} );
	}
}

export default MegaMenu;
